import clubsModule from "@clubs/module/store/type";

export default e => {
    if (
        app.$route.name !== 'clubs'
    ) {
        store.commit('updateUser', { has_club_notifications: true })
    }else{
        if(store.getters[clubsModule.getters.type] === 'my_clubs'){
            //show new club where user was invited
            app.$emit('reload-clubs')
            //remove clubs notification
            store.dispatch('signalClubsSeen')
        }else{
            if(app.isMobile){
                store.commit('updateUser', { has_club_notifications: true })
            }
        }
    }

    console.log('[Membership invite listener] Signal received', e);
}